// 発注時に表示する単位を商品情報から推定するユーティリティ
// 優先順位:
//   1. product.default_order_unit（管理画面で登録された発注デフォルト単位）
//   2. "g"（デフォルト）
//
// ※ product.unit は「最低発注単位（例: 0.25玉, 1個）」を表すため、表示単位には使用しない。
//   表示単位は管理画面で明示的に設定する `default_order_unit` または "g" を採用する。
export function deriveOrderUnit(product) {
  if (!product) return "g";
  if (product.default_order_unit) return String(product.default_order_unit).trim();
  return "g";
}
